import { formatSalesValue } from './../../utils/formatUtils';

const EmployeeTable = ({ employeeData, loading, handleIndividualDetails }) => {
    return (
        <div className="rounded-md border overflow-x-auto">
            <table className="text-center text-sm min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Employee</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Sales</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Guests</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Food</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Beverages</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Void</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Revenue per Guest</th>
                        <th className="px-4 py-3 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Discount</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {employeeData.length > 0 ? (
                        employeeData.map((employee, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 hover:underline">
                                    <div className='hover:cursor-pointer' onClick={() => handleIndividualDetails(employee)}>
                                        {employee.Employee}
                                    </div>
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Total_Sales)}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {employee.noOfGuests}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Food_Sales)}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Beverage_Sales)}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {employee.Void_Order_Count || '-'}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.RevperGuest)}
                                </td>
                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Discounts_Sales)}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className="px-4 py-6 text-center text-sm text-gray-700">
                                {loading ? "Loading data..." : "No employee data available"}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default EmployeeTable